<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("require-date.title") }}
                </p>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <label class="label">{{ action.title }}:</label>
                    <div class="control">
                        <DatePicker
                            v-model="answer"
                            :minDate="minDate"
                            :maxDate="maxDate"
                        />
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
                <button class="button" :disabled="isEmptyAnswer" @click="save">
                    <Icon
                        name="fa-paper-plane"
                        helperClass="has-text-primary"
                    />
                    <span> {{ $t("require-date.send") }}</span>
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import DatePicker from "@/components/external-components/datepicker/DatePicker";

export default {
    name: "require-date",
    components: {
        DatePicker,
    },
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            answer: null,
        };
    },
    computed: {
        ...mapGetters("conference", ["getConferenceId"]),
        isEmptyAnswer() {
            return (
                this.answer === null ||
                this.answer === undefined ||
                this.answer === ""
            );
        },
        minDate() {
            let minDate = this.action.minDate;
            return minDate !== null
                ? moment(minDate, "YYYY-MM-DDTHH:mm:ss").format("DD/MM/yyyy")
                : null;
        },
        maxDate() {
            let maxDate = this.action.maxDate;
            return maxDate !== null
                ? moment(maxDate, "YYYY-MM-DDTHH:mm:ss").format("DD/MM/yyyy")
                : null;
        },
    },
    methods: {
        ...mapActions("actions", ["setActionAnswer"]),
        save() {
            let actionResult = this.action;
            actionResult.answer = this.answer;
            this.setActionAnswer(actionResult);
            let roomId = this.getConferenceId;
            this.$emit("answered", {
                socketName: "SendDateActionAnswer",
                roomId: roomId,
                actionId: this.action.id,
                answer: this.answer,
                type: this.action.type,
            });
            this.answer = null;
        },
    },
};
</script>